export enum PhaseEffect {
	TV_GLITCH = "TV_GLITCH",
	DRONE = "DRONE",
}
